module.exports = __webpack_public_path__ + "static/img/bg_reward_item_black.d8c5cae7.png";